/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import styled from 'styled-components';

import useTranslation from '@src/hooks/useTranslation';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(var(--vh, 1vh) * 100);
`;

const FooterContainer = styled.div`
  padding: 20px;
  background-color: #ececec;
`;

const FooterLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const TextBase = `
	font-size: 14px;
	font-weight: 300;
	color: #222;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #222;
    opacity: 0.7;
  }
`;
const LinkText = styled.a`
  ${TextBase}
`;
const Text = styled.div`
  ${TextBase}
`;

const Divider = styled.div`
  width: 1px;
  height: 20px;
  background-color: #979797;
`;

interface LoginContainerProps {
  children: React.ReactNode;
}

const BusinessWrapper: React.FC<LoginContainerProps> = ({ children }) => {
	const { t } = useTranslation();

	const handleClickContactSupport = () => {
		window.open('mailto:support@dakastar.com.tw');
	};

	const links = [
		{
			type: 'link',
			label: t('theme:themeDesign:policy:title'),
			href: 'https://www.dakastar.com.tw/privacy',
		},
		{
			type: 'link',
			label: t('theme:themeDesign:terms:title'),
			href: 'https://www.dakastar.com.tw/policies',
		},
		{
			type: 'action',
			label: t('footer:contact'),
			onClick: handleClickContactSupport,
		},
	];

	return (
		<Wrapper>
			{children}
			<FooterContainer>
				<FooterLinks>
					{links.map((item, index) => (
						<React.Fragment key={item.label}>
							{item.type === 'link' ? (
								<LinkText
									href={item.href}
									target="_blank"
									rel="noreferrer noopener"
								>
									{item.label}
								</LinkText>
							) : (
								<Text onClick={item.onClick}>
									{item.label}
								</Text>
							)}
							{index !== links.length - 1 && <Divider />}
						</React.Fragment>
					))}
				</FooterLinks>
			</FooterContainer>
		</Wrapper>
	);
};

export default BusinessWrapper;
